module.exports = __webpack_public_path__ + "media/images/custom_page/tempest/gacha_2-2aa97478505e15dd041369832721318b.png";